module.exports = __webpack_public_path__ + "img/remove_file.d42ea736.svg";